import { IconProps } from 'components/Icons/IconProps';

export const ToastInfoIcon: import('react').FC<IconProps> = ({ size, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 46 46" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="40" height="40" rx="20" fill="#E6EDFD" />
    <rect x="3" y="3" width="40" height="40" rx="20" stroke="#F2F6FE" strokeWidth="6" />
    <path
      d="M15.798 25.2269C14.5987 25.2269 13.625 24.2318 13.625 23.0061C13.625 21.7803 14.5987 20.7973 15.7862 20.7973C16.9736 20.7973 17.9473 21.7925 17.9473 23.0061C17.9473 24.2197 16.9974 25.2269 15.798 25.2269ZM27.0076 14.875C25.4045 14.875 25.3333 16.2585 22.8871 16.2585C20.4172 16.2585 20.2154 14.875 18.7548 14.875C17.5555 14.875 16.5936 15.8701 16.5936 17.0837C16.5936 18.2973 17.5673 19.2925 18.7548 19.2925C20.3697 19.2925 20.441 17.909 22.8871 17.909C25.357 17.909 25.5589 19.2925 27.0195 19.2925C28.2188 19.2925 29.1806 18.2973 29.1806 17.0837C29.1806 15.8701 28.2069 14.875 27.0076 14.875ZM27.0076 26.7075C25.3927 26.7075 25.3214 28.091 22.8753 28.091C20.4054 28.091 20.2035 26.7075 18.7429 26.7075C17.5436 26.7075 16.5818 27.7027 16.5818 28.9163C16.5818 30.1299 17.5555 31.125 18.7429 31.125C20.3579 31.125 20.4291 29.7415 22.8753 29.7415C25.3452 29.7415 25.547 31.125 27.0076 31.125C28.2069 31.125 29.1688 30.1299 29.1688 28.9163C29.1688 27.7027 28.2069 26.7075 27.0076 26.7075ZM30.2137 20.7973C28.5869 20.7973 28.6463 22.2536 26.6039 22.2536C24.7158 22.2536 24.6921 20.8095 22.8753 20.8095C21.7472 20.8095 20.821 21.8653 20.821 23.0182C20.821 24.1711 21.7591 25.2269 22.9821 25.2269C24.6089 25.2269 24.5496 23.7706 26.592 23.7706C28.48 23.7706 28.5038 25.2148 30.3206 25.2148C31.4487 25.2148 32.3749 24.159 32.3749 23.0061C32.3868 21.8532 31.4487 20.7973 30.2137 20.7973Z"
      fill="#195AFF"
    />
  </svg>
);
export const ToastWarningIcon: import('react').FC<IconProps> = ({ size, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 46 46" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="40" height="40" rx="20" fill="#FEF0C7" />
    <rect x="3" y="3" width="40" height="40" rx="20" stroke="#FFFAEB" strokeWidth="6" />
    <path
      d="M22.9998 19.6667V23M22.9998 26.3333H23.0081M21.5748 15.3833L14.5164 27.1667C14.3709 27.4187 14.2939 27.7044 14.2931 27.9954C14.2923 28.2865 14.3677 28.5726 14.5118 28.8254C14.6559 29.0783 14.8637 29.289 15.1145 29.4366C15.3653 29.5841 15.6504 29.6635 15.9414 29.6667H30.0581C30.3491 29.6635 30.6342 29.5841 30.885 29.4366C31.1358 29.289 31.3436 29.0783 31.4878 28.8254C31.6319 28.5726 31.7073 28.2865 31.7065 27.9954C31.7056 27.7044 31.6286 27.4187 31.4831 27.1667L24.4248 15.3833C24.2762 15.1384 24.067 14.9359 23.8174 14.7954C23.5678 14.6549 23.2862 14.5811 22.9998 14.5811C22.7133 14.5811 22.4317 14.6549 22.1821 14.7954C21.9325 14.9359 21.7233 15.1384 21.5748 15.3833Z"
      stroke="#DC6803"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ToastErrorIcon: import('react').FC<IconProps> = ({ size, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 46 46" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="40" height="40" rx="20" fill="#FEE4E2" />
    <rect x="3" y="3" width="40" height="40" rx="20" stroke="#FEF3F2" strokeWidth="6" />
    <g clipPath="url(#clip0_1135_4736)">
      <path
        d="M23 19.6666V23M23 26.3333H23.0083M31.3333 23C31.3333 27.6023 27.6023 31.3333 23 31.3333C18.3976 31.3333 14.6666 27.6023 14.6666 23C14.6666 18.3976 18.3976 14.6666 23 14.6666C27.6023 14.6666 31.3333 18.3976 31.3333 23Z"
        stroke="#D92D20"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1135_4736">
        <rect width="20" height="20" fill="white" transform="translate(13 13)" />
      </clipPath>
    </defs>
  </svg>
);
export const ToastSuccessIcon: import('react').FC<IconProps> = ({ size, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 46 46" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="40" height="40" rx="20" fill="#D1FADF" />
    <rect x="3" y="3" width="40" height="40" rx="20" stroke="#ECFDF3" strokeWidth="6" />
    <g clipPath="url(#clip0_1135_4967)">
      <path
        d="M31.3333 22.2333V23C31.3323 24.797 30.7504 26.5455 29.6744 27.9848C28.5984 29.4241 27.086 30.477 25.3628 30.9866C23.6395 31.4961 21.7977 31.4349 20.112 30.8121C18.4264 30.1894 16.9872 29.0384 16.0091 27.5309C15.031 26.0233 14.5665 24.24 14.6847 22.4469C14.8029 20.6538 15.4976 18.9469 16.6652 17.5809C17.8328 16.2148 19.4106 15.2628 21.1635 14.8668C22.9163 14.4707 24.7502 14.6519 26.3916 15.3833M31.3333 16.3333L23 24.675L20.5 22.175"
        stroke="#039855"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1135_4967">
        <rect width="20" height="20" fill="white" transform="translate(13 13)" />
      </clipPath>
    </defs>
  </svg>
);
